import './FirePopUp.scss';
import React, { useEffect, useRef, useState } from "react";
import WeatherConditions from '../../WeatherConditions';
import historicalFireIcon from '../../../assets/icons/historical-fire-icon.png';
import calendar from '../../../assets/icons/calendar-icon.png';
import location from '../../../assets/icons/location-icon.png';
import left from '../../../assets/icons/left.png';
import moment from 'moment-timezone';
import LiveTime from './LiveTime';
import PieChart from './PieChart';
import RiskComponent from '../../RiskComponent';
import Comments from '../../Comments';
import optionsIcon from '../../../assets/icons/options-icon.png';
import { useFiresContext } from '../../../contexts/FiresContext';
import mapboxgl from 'mapbox-gl';

export default function HistoricalFirePopup(props) {
    const {
        setModal
    } = useFiresContext();

    const {
        panel,
        setPanel,
        user,
        setUser,
        fire,
        map
    } = props;

    const fireRef = useRef(null);
    const userSub = user?.accessToken.payload.sub;
    const [tab, setTab] = useState('Details');

    useEffect(() => {
        setTab('Details');
    }, [fire]);

    const WKTtoRings = (wkt) => {
        const rings = wkt.slice(9).slice(0, -2).split(',').map((coordinates) => {
            return coordinates.split(' ').filter((element) => element !== '').map((element) => parseFloat(element));
        });
        return rings;
    };

    useEffect(() => {
        if (fireRef.current) {
            fireRef.current.remove();
        }

        const point = document.createElement('div');
        point.className = 'map-fire-marker';
        const marker = new mapboxgl.Marker(point).setLngLat([fire.longitude, fire.latitude]).addTo(map.current);
        fireRef.current = marker;

        if (fire.geom) {
            if (map.current.getSource('Historical Fire perimeters Source')) {
                map.current.removeSource('Historical Fire perimeters Source');
            }
        
            map.current.addSource('Historical Fire perimeters Source', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: [
                        {
                            type: 'Feature',
                            properties: fire,
                            geometry: {
                                type: 'Polygon',
                                coordinates: [WKTtoRings(fire.geom)],
                            },
                        }
                    ]
                }
            });
        
            map.current.addLayer({
                id: 'Historical Fire perimeters Layer',
                type: 'fill',
                source: 'Historical Fire perimeters Source',
                paint: {
                    'fill-color': '#FFAB91',
                    'fill-opacity': 0.5,
                },
            });
        
            map.current.addLayer({
                id: 'Historical Fire perimeters Layer Outline',
                type: 'line',
                source: 'Historical Fire perimeters Source',
                paint: {
                    'line-color': '#E64A19',
                    'line-width': 2,
                },
            });
        }

        return () => {
            fireRef.current.remove();

            if (map.current.getSource('Historical Fire perimeters Source')) {
                map.current.removeSource('Historical Fire perimeters Source');
            }

            const perimetersLayers = map.current.getStyle().layers?.filter(layer => layer.id.includes('Historical Fire perimeters Layer')) || [];
            perimetersLayers.forEach(layer => {
                if (map.current.getLayer(layer.id)) {
                    map.current.removeLayer(layer.id);
                }
            });
        }
    }, []);

    const formatDate = (timestamp) => {
        const time = moment.utc(timestamp).local();
        return time.format('YYYY-MM-DD hh:mm:ss A');
    }

    const getUploaderText = (fire) => {
        if (panel.name === 'Historical Fire PopUp') {
            const userSub = user?.accessToken.payload.sub;
    
            if (!fire?.fire_id.toUpperCase().includes('USER-')) {
                return 'Space-Eyes';
            }
        
            if (fire?.cognito_user_id === userSub) {
                return 'You';
            }
        
            return 'Community User';
        }
    };

    const formatType = (type) => {
        switch (type) {
            case 'FI': return 'Fire Incident';
            case 'FM': return 'Fire Monitoring'
            case 'L': return 'Large Fire'
        }
    }


    const stageSwitch = (stage) => {
        switch (stage) {
            case 'Details':
                return (
                    <div 
                        className='fire-popup-details'
                        style={{ marginTop: 0 }}
                        >
                        <div className='fire-popup-details-fields'>
                            <div className='fire-popup-details-fields-left'>
                                <div className='fire-popup-details-fields-left-field'>
                                    <div className='fire-popup-details-fields-left-field-value'>Type</div>
                                    <div className='fire-popup-details-fields-left-field-title'>{fire.type ? formatType(fire.type) : 'Not Available'}</div>
                                </div>
                                <div className='fire-popup-details-fields-left-field'>
                                    <div className='fire-popup-details-fields-left-field-value'>Fuels</div>
                                    <div className='fire-popup-details-fields-left-field-title'>{fire.fuels ? fire.fuels : 'Not Available'}</div>
                                </div>
                            </div>
                            <div className='fire-popup-details-fields-right'>
                                <div className='fire-popup-details-fields-right-field'>
                                    <div className='fire-popup-details-fields-right-field-value'>Area (Acres)</div>                               
                                    <div className='fire-popup-details-fields-right-field-title'>{fire.areaAc ? fire.areaAc.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : fire.areaAC ? fire.areaAC.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 'Not Available'}</div>
                                </div>
                                <div className='fire-popup-details-fields-right-field'>
                                    <div className='fire-popup-details-fields-right-field-value'>Cause</div>
                                    <div className='fire-popup-details-fields-right-field-title'>{fire.cause ? fire.cause : 'Not available'}</div>
                                </div>
                            </div>
                        </div>
                        <WeatherConditions coordinates={[fire.latitude, fire.longitude]}/>
                    </div>
                )
            case 'Risk':
                return (
                    <RiskComponent 
                        user={user} 
                        setUser={setUser} 
                        coordinates={[fire.longitude, fire.latitude]}
                    />
                )
            case 'Comments':
                return (
                    <Comments 
                        user={user} 
                        setUser={setUser}
                        id={fire.fire_id}
                    />
                )
        }
    }

    return (
        fire && panel.name === 'Historical Fire PopUp' ?
        <div className='fire-popup'>
            {userSub === fire.cognito_user_id &&
            <img 
                src={optionsIcon}
                className='fire-popup-options'
                onClick={() => {
                    setModal({
                        type: 'edit-and-delete',
                        content: fire
                    })
                }}
            />}
            <div className='fire-popup-back-btn' 
                onClick={() => {
                    setPanel({
                        name: 'Fires', 
                        content: null
                    });
                }}
            >
                <img 
                    src={left} 
                    className="fire-popup-back-btn-icon"
                />
                Back to results
            </div>
            <div className='fire-popup-header'>
                <div className='fire-popup-header-title'>
                    <img src={historicalFireIcon} className='fire-popup-header-title-icon'/>
                    <div className='fire-popup-header-title-text'>{fire.name ? fire.name : 'Not Available'}</div>
                </div>
                <div className='fire-popup-header-datasource'>
                    {`Uploaded by ${getUploaderText(fire)}`} 
                </div>
            </div>
            <div className="fire-popup-main">
                <div className="fire-popup-main-left">
                    <div className="fire-popup-main-left-subheader">
                        <div className="fire-popup-main-left-subheader-status">
                            <div className="fire-popup-main-left-subheader-status-title">Status</div>
                            <div
                                className="fire-popup-main-left-subheader-status-value"
                                style={{
                                    color: fire.active ? '#f44336' : '#37c13e',
                                }}
                            >
                                {fire.active ? 'Active' : 'Contained'}
                            </div>
                        </div>
                        {fire.updatedTimestamp && (
                            <div className="fire-popup-main-left-subheader-lastupdated">
                                <div className="fire-popup-main-left-subheader-lastupdated-title">Last Updated</div>
                                <LiveTime value={fire.updatedTimestamp}/>
                            </div>
                        )}
                    </div>
                    <div className="fire-popup-main-left-date">
                        <img src={calendar} className="fire-popup-main-left-date-icon" alt="Calendar" />
                        <div className="fire-popup-main-left-date-value">
                            {fire.startTimestamp
                                ? formatDate(fire.startTimestamp)
                                : fire.starttimestamp
                                ? formatDate(fire.starttimestamp)
                                : 'Not Available'
                            }
                        </div>
                    </div>
                    <div className="fire-popup-main-left-location">
                        <img src={location} className="fire-popup-main-left-location-icon" alt="Location" />
                        <div className="fire-popup-main-left-location-value">
                            {`${fire.latitude.toFixed(5)}, ${fire.longitude.toFixed(5)}`}
                        </div>
                    </div>
                </div>
                <div className="fire-popup-main-right">
                    <PieChart 
                        percentage={fire.perContained}
                        size={90}
                        type='containment'
                    />
                    <div className="fire-popup-main-right-caption">Containment</div>
                </div>
            </div>
            <div className='fire-popup-tabs'>
                {['Details', 'Risk', 'Comments'].map((t, index) => (
                    <div
                        key={index}
                        className='fire-popup-tabs-tab'
                        style={{
                            borderBottom: t === tab ? '2px solid #0080ff' : '',
                            width: '33%'
                        }}
                        onClick={() => setTab(t)}
                    >
                        <div className='fire-popup-tabs-tab-container-text'>{t}</div>
                    </div>
                ))}
            </div>
            {stageSwitch(tab)}
        </div>
        :
        <></>
    )
}